/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';

import { type AvatarIconProps } from './types';

export const FeatureFlagAvatar = ({ size, primaryColor, secondaryColor }: AvatarIconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 42 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z"
			fill={primaryColor}
		/>
		<g clipPath="url(#clip0_7126_44811)">
			<path
				d="M18.4674 12.327C18.3867 10.7241 18.0617 8.58558 18.0098 7.815C18.427 8.74089 18.2636 6.33955 18.1732 5.9453C18.1348 6.3495 17.9618 6.03691 17.9983 5.76213C18.6174 6.14841 18.1963 -0.402498 17.6542 2.96654C17.5138 4.55548 17.2485 8.03603 17.21 10.5668C17.533 11.8033 18.1367 16.9982 18.4674 12.329V12.327Z"
				fill={secondaryColor}
			/>
			<path
				d="M12.3998 15.0647C12.0115 14.3041 11.5943 13.645 10.7849 12.8386C10.8521 13.5056 10.508 13.0477 10.4772 12.7331C11.054 12.8585 10.2792 11.9923 10.0062 11.8729C10.085 11.9943 9.94468 12.1038 9.81394 11.9187C10.3004 11.8788 8.56619 9.75627 8.40085 10.71C8.62387 11.0445 8.38162 11.1959 8.78152 11.0505C8.34509 11.4368 9.04684 11.4308 9.07568 11.4965C8.80652 11.9226 9.6313 11.9884 9.28523 12.0999C9.41789 12.9122 12.4729 16.8448 12.3998 15.0667V15.0647Z"
				fill={secondaryColor}
			/>
			<path
				d="M9.4909 22.1992C8.60074 21.4624 7.61638 20.9706 6.19943 20.7118C6.78967 21.2773 6.10329 21.0463 5.80337 20.8133C7.12995 20.3096 -0.123965 19.9432 2.62918 21.0921C2.75222 20.4589 2.66763 21.2812 3.03869 21.0483C3.32323 20.8412 3.59431 20.9089 3.58855 21.0722C3.58662 21.2534 4.34989 20.7735 4.14225 21.116C4.77863 21.2155 10.9559 23.7264 9.4909 22.1992Z"
				fill={secondaryColor}
			/>
			<path
				d="M8.58349 28.6863C7.55683 29.0327 6.60901 29.5803 5.69193 30.6356C6.45136 30.4265 5.89187 30.9084 5.55926 31.0159C5.89379 29.5544 1.74295 35.4801 4.11157 33.8055C3.64054 33.3555 4.30767 33.8712 4.29421 33.4431C4.48455 32.5292 5.3824 32.5909 6.10529 31.5276C6.51481 30.8287 10.2254 28.8993 8.58349 28.6883V28.6863Z"
				fill={secondaryColor}
			/>
			<path
				d="M38.6205 20.3191C37.54 20.2215 36.5883 20.2295 35.206 20.3589C36.0019 20.7432 34.9541 20.789 34.8599 20.4585C35.504 20.2793 33.8294 20.2056 33.6602 20.3788C33.8755 20.4027 33.7813 20.5859 33.5429 20.56C33.7217 20.0941 29.4863 20.11 31.73 21.0419C31.7992 21.0299 31.7511 20.6675 31.8568 20.777C31.8261 21.3724 32.4394 20.8328 32.5221 20.8547C32.5874 21.3166 33.4737 20.775 33.2661 21.0936C33.7121 21.6412 40.6834 21.2928 38.6186 20.3191H38.6205Z"
				fill={secondaryColor}
			/>
			<path
				d="M28.6322 9.25067C28.5534 8.19337 29.5916 7.45664 29.7858 6.39536C29.3743 4.68495 26.1079 11.2637 27.1788 10.0292C27.4998 9.63696 23.7239 15.4969 25.0735 15.5009C25.1216 15.6084 25.5888 14.9434 25.5003 14.8956C25.4138 14.808 25.2831 14.7881 25.3734 14.7064C25.8945 14.9533 25.6945 13.9896 25.758 13.8921C26.7519 13.2191 27.396 10.4792 28.6341 9.24671L28.6322 9.25067Z"
				fill={secondaryColor}
			/>
			<path
				d="M17.5431 28.7838L15.8442 14.8184L33.301 12.6947L28.9134 20.3145L34.9999 26.6602L17.5431 28.7838Z"
				fill="#101214"
			/>
			<path
				d="M13.226 15.1368L9.73462 15.5615L12.3891 37.3825L15.8805 36.9578L13.226 15.1368Z"
				fill="white"
			/>
			<path
				d="M25.4516 36.575C24.5175 36.3381 24.2405 37.4215 24.0948 35.5869C23.9577 34.7433 23.3407 34.9773 23.1294 35.2575C23.0008 35.4251 23.4007 36.2225 23.2436 36.2976C23.2436 36.2976 23.2608 36.9563 23.3036 37.3146C23.2579 36.9332 21.824 37.1412 21.1613 37.4243C21.1613 37.4243 20.6901 38.005 21.3584 38.3604C21.3984 38.3488 22.6838 38.1842 23.0494 38.3257C23.6492 38.7533 23.1865 38.8631 23.295 39.3254C23.4036 39.7847 23.3921 41.8158 24.6832 40.6312C24.7318 39.7067 24.7232 39.5276 24.5575 38.2564C24.7632 37.9068 25.0774 37.6555 25.5515 37.7364C25.8029 37.6613 25.8515 36.3698 25.4544 36.575H25.4516Z"
				fill={secondaryColor}
			/>
			<path
				d="M29.2653 33.6133C30.0565 33.9889 31.0505 33.3475 31.5218 34.1391C30.9191 33.8907 30.9991 37.086 31.9931 36.3291C32.1131 35.8321 32.4015 35.8928 31.8931 35.7224C32.7472 35.7166 31.9531 35.1677 31.9817 35.0897C32.4472 35.0781 31.8388 34.8123 32.2816 34.9048C32.5386 34.8528 31.7874 34.1941 32.2959 34.3703C32.4587 33.6538 33.2527 33.6595 33.0756 33.2233C33.0842 33.5209 35.7235 33.5902 34.9922 32.4519C34.5295 32.475 34.5895 31.9492 34.5209 32.6339C34.381 31.7846 34.0696 32.6339 33.9954 32.6137C33.9268 32.137 33.7897 32.7957 33.8097 32.3306C33.7412 32.0792 33.2956 32.8824 33.3841 32.3566C31.8446 31.9492 33.1071 31.5101 32.2187 30.626C32.1302 30.2158 32.3473 28.8839 31.3961 29.0081C30.145 29.3722 31.6046 31.6459 30.862 32.0417C30.5306 32.3421 30.0593 32.7206 29.4338 32.4635C29.1253 32.4577 28.7283 33.7318 29.2624 33.6162L29.2653 33.6133Z"
				fill={secondaryColor}
			/>
		</g>
		<defs>
			<clipPath id="clip0_7126_44811">
				<rect width="42" height="42" fill="white" transform="translate(0 3)" />
			</clipPath>
		</defs>
	</svg>
);
